import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import DwtReportCriteria from "./DwtReportCriteria";

@NeoReport("DWT", { category: ReportCategory.InvestorReports })
export default class DwtReport extends Report<DwtReportCriteria> {

    constructor() {
        super(DwtReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.startDate} />
                <Neo.FormGroup bind={this.criteria.meta.endDate} />
            </Neo.GridLayout>
        </div>;
    }
}